import { API_BASE, api } from './client';
import { billingSchema, partnerBillingSchema, type Billing, type PartnerBilling } from './orgTypes';

export async function fetchBilling(month: string, partnerId?: string): Promise<Billing> {
  return billingSchema.parse(
    await api.get<unknown>('/usage/billing', { query: { month, partner_id: partnerId } }),
  );
}

export async function fetchPartnerBilling(month: string): Promise<PartnerBilling> {
  return partnerBillingSchema.parse(
    await api.get<unknown>('/usage/billing/partners', { query: { month } }),
  );
}

/** A CSV export is a plain GET: a link carries the session cookie, no header is needed. */
export function billingExportUrl(month: string, partnerId?: string): string {
  const params = new URLSearchParams({ month });
  if (partnerId) params.set('partner_id', partnerId);
  return `${API_BASE}/usage/billing/export.csv?${params.toString()}`;
}
